module.exports = __webpack_public_path__ + "img/IMG-20210116-WA0040.5c3a28bf.jpg";